import axios from "axios";

let baseURL = "";
if(process.env.NODE_ENV === 'production'){
	//baseURL = "https://www.tlsengenharia.com.br:32592/api";
  baseURL = "https://www.tlsengenharia.com.br:53074/api";//Teste
}else{
  //baseURL = "https://162.215.217.77:53074/api"; 
  //baseURL = "https://localhost:7222/api";  
  //baseURL = "https://www.tlsengenharia.com.br:32592/api";
  baseURL = "https://www.tlsengenharia.com.br:53074/api";//Produção
}

export default axios.create({
  baseURL: baseURL
});

export const axiosPrivate = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'X-Requested-With',
		'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8' ,
    //'Accept': "application/json",
    //'Access-Control-Allow-Credentials':true
  }
});
